
import HeaderNavigation from '~/components/Organisms/Header/HeaderNavigation.vue'
import NavigationDesktop from '~/components/Organisms/Header/NavigationDesktop.vue'
import SignInDropdown from '~/components/Atoms/SignInDropdown/SignInDropdown.vue'
import MonksPrimaryButton from '~/components/Atoms/MonksPrimaryButton/MonksPrimaryButton.vue'

export default {
  name: 'MonksHeaderWrapper',

  components: {
    HeaderNavigation,
    NavigationDesktop,
    SignInDropdown,
    MonksPrimaryButton,
  },

  props: {
    isPT: {
      type: Boolean,
      default: false,
    },
    navigation: {
      type: Object,
      required: true,
    },
    topbarVisible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isAtTop: true,
      menuOpen: false,
      isDropdownOpen: false,
    }
  },

  computed: {
    isTopStripePage() {
      const currentPath = this.$route ? this.$route.path : ''

      return (
        this.isPT &&
        (currentPath.includes('/about') ||
          currentPath.includes('/payments') ||
          currentPath.includes('/app-hotmart') ||
          currentPath.includes('/solutions'))
      )
    },

    showTopbarSpace() {
      return this.isAtTop && this.topbarVisible && this.isTopStripePage
    },

    wrapperClasses() {
      return [
        'header__wrapper',
        {
          'header__wrapper--es': !this.isPT || !this.isTopStripePage,
          'header-wrapper-topbar-space': this.showTopbarSpace,
          'header__wrapper-open-by-dropdown': this.isDropdownOpen,
          'header--menu': this.menuOpen,
        },
      ]
    },
  },

  mounted() {
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('dropdown:toggle', this.handleDropdownToggle)
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('dropdown:toggle', this.handleDropdownToggle)
  },

  methods: {
    handleScroll() {
      const scrollMinimum = window.innerWidth < 768 ? 50 : 10
      this.isAtTop = window.scrollY <= scrollMinimum
    },

    handleDropdownToggle(event) {
      this.isDropdownOpen = event.detail.isActive
    },

    toggleMenu() {
      this.menuOpen = !this.menuOpen

      if (this.menuOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }

      this.$emit('toggle-menu', this.menuOpen)
    },

    closeMenu() {
      this.menuOpen = false
      document.body.style.overflow = ''
      this.$emit('toggle-menu', false)
    },
  },
}
